module.exports = __webpack_public_path__ + "static/img/bilaxy.e8263589.png";